import ApiClient from '../ApiClient';

class MyAiAgentSessions extends ApiClient {
  constructor() {
    super('my_ai/agent_sessions', { accountScoped: true });
  }
}

export default new MyAiAgentSessions();
